import React from "react";
import * as PropTypes from "prop-types";
import CurrentSpendingBySectorTable from "./CurrentSpendingBySectorTable";
import DataViewerFrame from "../../widgets/DataViewerFrame";

const CurrentSpendingBySectorTableWidget = props => (
  <DataViewerFrame
    reference="Table 1.1"
    title="Current Spending by Sector"
    subtitle="Segmented by GNI Group"
    onDownloadCsv={props.onDownloadCsv}
  >
    <CurrentSpendingBySectorTable data={props.data} />
  </DataViewerFrame>
);

CurrentSpendingBySectorTableWidget.propTypes = {
  data: PropTypes.array.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default CurrentSpendingBySectorTableWidget;
